import app from './app';

import './components';
import './directives';

import '@collectivehealth/dls-ng-member-footer/dist/index.css';

export default app.name;
